import { createFileRoute, notFound } from '@tanstack/react-router'
import InvoicePdfPage from '../../Pages/InvoicePdfPage/InvoicePdfPage'
import PageBody from '../../Pages/Layout/PageBody'
import PageSidebar from '../../Pages/Layout/PageSidebar'
import InvoicePdfSidebar from '../../Pages/InvoicePdfPage/InvoicePdfSidebar'
import { processTRPCData } from '../../Queries/fetchData'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import { idf } from '../../Queries/queryFormatter'
import InvoiceCollection from '../../State/Collections/InvoiceCollection'
import { setLayoutDefaults } from '@2/layout/layout-store'
import { getCacheItemById } from '@2/cache'
import { CenterPadPageBody } from '@2/layout/page-body'
import { useSidebarStack } from '@2/layout/sidebar'
import { useEffect } from 'react'
import { trpc } from '../../system/trpc'

export const Route = createFileRoute('/_private/invoices/$id/pdf')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'invoicePdf', params))
            throw new Error('Permission Denied')
        const invoice = getCacheItemById('invoices', params.id)
        setLayoutDefaults({
            pageTitle: invoice?.ref || 'Invoice',
            subMenu: 'invoices',
            tabs: [
                {
                    id: 'details',
                    label: 'Details',
                    url: `/invoices/${params.id}`,
                },
                {
                    id: 'pdf',
                    label: 'PDF',
                    url: `/invoices/${params.id}/pdf`,
                },
            ],
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async ({ params }) => await loader(params.id),
    pendingComponent: LoadingSpinner,
    component: Wrapper,
})

const loader = async (id) => {
    const data = await trpc.legacy.getInvoicePageData.query({
        id,
    })
    const processedModels = processTRPCData(data)
    const invoice =
        InvoiceCollection.invoicesById[id] ||
        InvoiceCollection.invoicesByOldId[id]
    if (!invoice) {
        throw notFound()
    }
    return processedModels
}

function Wrapper() {
    const { id } = Route.useParams()
    const { addToSidebar } = useSidebarStack()
    useEffect(() => {
        addToSidebar(<InvoicePdfSidebar id={id} />, { hideClose: true })
    }, [])
    if (migratedToV2()) {
        return (
            <>
                <CenterPadPageBody>
                    <InvoicePdfPage id={id} />
                </CenterPadPageBody>
            </>
        )
    }
    return (
        <>
            <PageBody>
                <InvoicePdfPage id={id} />
            </PageBody>

            <PageSidebar>
                <InvoicePdfSidebar id={id} />
            </PageSidebar>
        </>
    )
}
